import { createCommand } from '../../utils';
import { currentProjectIdQuery, projectSectionsFilterQuery, projectSectionsSortQuery } from '../queries';
import { moduleName, resetStarted, resetWith } from '../state';

export const InitProjectCommand = createCommand(
    `${moduleName}/INIT_PROJECT`,
    async (_, { dispatch, extra, getState }) => {
        dispatch(resetStarted());
        const state = getState();
        const projectId = currentProjectIdQuery(state);
        const projectSections = await extra.externalProject.loadProjectSections(projectId ?? undefined);

        let sort = projectSectionsSortQuery(state);
        if (sort.length === 0) {
            sort = extra.externalProjectConfiguration.loadProjectSectionsSort();
        }
        let filter = projectSectionsFilterQuery(state);
        if (filter.items.length === 0) {
            filter = extra.externalProjectConfiguration.loadProjectSectionsFilter();
        }
        dispatch(resetWith({ projectSections, sort, filter }));
    },
);
